import React, { useEffect } from "react";
// import ServicesButtonList from "../components/ServicesButtonList";
import AOS from "aos";
import "aos/dist/aos.css";
import Schema from "./Schema";
import ServiceNavigator from "./ServiceNavigator";


const Warranty = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
      {/* Hero Section with Black Background */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Warranty Handling Services
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4">
            Support for Solar Panels, Inverters, and DC/AC Components in Sri Lanka
          </p>
          <p className="italic text-gray-400">
            Reliable warranty support when you need it most
          </p>
        </div>
      </section>

      {/* Info Block */}
      <section
        className="px-6 py-14 max-w-4xl mx-auto text-lg leading-relaxed space-y-14"
        data-aos="fade-up"
      >
        <div>
          <p className="mb-6 text-justify text-gray-700">
            We offer specialized support for solar system owners who have been left without assistance due to lost contact or neglect by their original installers. Our warranty handling services ensure your system remains protected and operational.
          </p>

          <article className="mb-6">
            <h3 className="text-2xl font-bold mb-3 text-black">Manufacturer Warranty Claims Management</h3>
            <p className="text-gray-700 text-justify">
              We coordinate with global manufacturers to process valid warranty claims on your behalf, saving you time and hassle.
            </p>
          </article>

          <article className="mb-6">
            <h3 className="text-2xl font-bold mb-3 text-black">Component Testing & Diagnostics</h3>
            <p className="text-gray-700 text-justify">
              Our team performs professional assessments of faulty solar panels, inverters, and both DC and AC components to determine the root cause of issues.
            </p>
          </article>

          <article className="mb-6">
            <h3 className="text-2xl font-bold mb-3 text-black">Replacement & Reinstallation Services</h3>
            <p className="text-gray-700 text-justify">
              We source certified replacement parts and carry out international-standard installations to restore your system to peak condition.
            </p>
          </article>

          <article className="mb-6">
            <h3 className="text-2xl font-bold mb-3 text-black">Technical Documentation & Reporting</h3>
            <p className="text-gray-700 text-justify">
              You’ll receive all necessary reports and images to support manufacturer communication and expedite the claims process.
            </p>
          </article>

          <article className="mb-6">
            <h3 className="text-2xl font-bold mb-3 text-black">Support for All Brands</h3>
            <p className="text-gray-700 text-justify">
              We support Tier-1 solar modules, hybrid and string inverters, and other key components, regardless of brand or installer.
            </p>
          </article>

          <p className="text-gray-700 italic mt-6 text-justify">
            Whether your installer has gone out of business, is unresponsive, or has failed to honor service commitments — we're here to ensure your system continues to perform safely and efficiently.
          </p>
        </div>
      </section>

      {/* Contact Section with Flex Styling */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">Book Your Warranty Service</h2>
          <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
        </div>
      </section>

      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default Warranty;